"use strict";
/**
 * Created on 07 03 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SelloutTerminationItem}.</p>
 *
 * @author JMe
 */


var SelloutTerminationItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutTerminationItemConverter, _DataObjectConverter_);

  function SelloutTerminationItemConverter() {
    _classCallCheck(this, SelloutTerminationItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationItemConverter).apply(this, arguments));
  }

  return SelloutTerminationItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutTerminationItemConverter = SelloutTerminationItemConverter;